import styled from "styled-components";
import {
  Button,
  Table,
  Responsive,
  Form,
  Button as SemanticButton,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { darken } from "polished";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 5vh;
  position: relative;
  top: 0;
  background-color: #fff;
`;
export const TextWhite = styled.p`
  color: white;
`;

export const Content = styled.section`
  width: 80%;
  margin: 0 auto 0 auto;
  height: auto;
  padding: 51px 0 0 0;

  ${(props) =>
    props.logged &&
    `
      @media screen and (max-width: 800px) {
        padding: 2rem;
      }

      @media screen and (max-width: 600px) {
        padding: 0.5rem;
      }
  `}
`;

const MessageColor = {
  warn: "#b58105",
  error: "#db2828",
};

const Messagebackgrond = {
  warn: "#fff8db",
  error: "#ffe8e6",
};

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;

  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    background: #fcfff5 !important;
    color: #2c662d !important;
    font-size: 14px;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }

    td {
      a {
        font-family: sans-serif !important;
      }
    }
  }
`;

export const Redirect = styled(Link)`
  color: #2185d0 !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #2d8cd4 !important;
  }
`;

export const RedirectButton = styled.button`
  width: 110px;
  height: 30px;

  background: #e0e1e2;
  color: rgba(0, 0, 0, 0.6);

  font-family: sans-serif;
  font-size: 11px;
  font-weight: 600;

  border: 0px;
  border-radius: 5px;

  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
  }
`;

export const TableButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "edit" ? "#2185d0" : "#000")};
    }
  }
`;

export const Field = styled(Form.Field)`
  margin: 20px 0 !important;
  width: ${(props) => (props.big && "80%") || (props.small && "20%")};
`;
export const Label = styled.label`
  color: ${(props) => `${props.color}`};

  font-size: 12px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const SubmitButton = styled(RedirectButton)`
  background-color: #21ba45;
  color: #fff;
  text-shadow: none;
  background-image: none;
  height: 38px;
  font-size: 14px;

  &:hover {
    background: #16ab39;
  }
`;

export const WarningRed = styled(Responsive)`
  background-color: #ffe8e6 !important;
  color: #db2828;
  box-shadow: 0 0 0 1px #db2828 inset, 0 0 0 0 transparent !important;
  font-family: sans-serif;
  font-size: 14px;
`;

export const WarningYellow = styled(Responsive)`
  background-color: #fff8db !important;
  color: #b58105;
  box-shadow: 0 0 0 1px #b58105 inset, 0 0 0 0 transparent !important;
  font-family: sans-serif;
  font-size: 14px;
`;

export const FaixaPreview = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  height: 80px;
  width: 100%;
  padding: 20px;

  background-color: ${(props) => props.backgroundColor || "#000"};
  color: ${(props) => props.color || "#fff"};

  margin-bottom: 50px;

  box-shadow: 0px 0px 10px #cecece;

  & > p {
    margin: 0 32px 0 0;
    font-size: 18px;
    color: ${(props) => props.color || "#fff"};
  }
`;

export const ButtonFaixa = styled(SemanticButton)`
  background-color: ${(props) => props.backgroundColor || "#f2711c"} !important;
  color: ${(props) => props.color || "#fff"} !important;

  &:hover {
    background-color: ${(props) =>
      darken("0.1", props.backgroundColor || "#f2711c")} !important;
  }
`;

export const ContainerTimer = styled.a`
  width: auto;
  height: min-content;
  margin: 0px 32px 0px 0px;
  font-weight: bold;
  cursor: default;
  text-transform: uppercase;
  }
`;

export const ContainerFlip = styled.div`
  --border: whitesmoke;
  --font-family: "Droid Sans Mono", monospace;
  --font-size: 16px;
  --font-width: 400;
  --width: 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(4 * var(--width) + var(--width));
  margin: 0px;

  & > span {
    font-weight: var(--font-width);
    font-size: 18px;
    margin-top: 8px !important;
    margin-left: 3px;
    margin-right: 3px;
    color: ${(props) => props.colorUnit};
  }
`;

export const FlipUnitContainerStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 500;

  & > p {
    margin-bottom: 0px};
    font-size: 6px;
    font-weight: 800;
    color: ${(props) => props.colorUnit};
  }
`;

export const FlipDigitContainerStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: var(--width);
  height: calc(var(--width) * 7 / 8);
  perspective-origin: 50% 50%;
  perspective: 300px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 3px;
  box-shadow: 0px 10px 10px -10px grey;

  font-size: var(--font-size);
  font-family: var(--font-family);
  font-weight: var(--font-width);
  color: ${(props) => props.color};
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: left;
`;
